export const DateTimeFormat = 'yyyy-LL-dd hh:mm:ss a z';
export const DateFormat = 'yyyy-LL-dd';
export const TimeFormat = 'hh:mm:ss a z';

// Size In MB
export const MAX_FILE_SIZE = 5;
